import { EntityStatusInput, RemoveFormItem } from "@/components";
import { selectFilterHelper } from "@/helpers";
import { optionFieldType, optionType } from "@/propTypes";
import { Form, Input, Select, Space } from "antd";
import { arrayOf, bool, func } from "prop-types";
import { useIntl } from "react-intl";

export const OptionEditLocationValue = ({
  field,
  remove,
  availableDependantValues,
  labelDisabled,
  isNew,
}) => {
  const intl = useIntl();

  return (
    <Space key={field.key} style={{ display: "flex", alignItems: "center" }}>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "label", "fallback"]}
        fieldKey={[field.fieldKey, "label", "fallback"]}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.optionLabelRequired",
            }),
          },
        ]}
      >
        <Input
          disabled={labelDisabled}
          placeholder={intl.formatMessage({
            id: "newFormField.optionLabelPlaceholder",
          })}
        />
      </Form.Item>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "dependsOnPropertyValues"]}
        fieldKey={[field.fieldKey, "dependsOnPropertyValues"]}
      >
        <Select
          mode="multiple"
          style={{ maxWidth: 400, minWidth: 150 }}
          allowClear
          placeholder={intl.formatMessage({
            id: "newFormField.dependentValuesPlaceholder",
          })}
          filterOption={selectFilterHelper}
        >
          {availableDependantValues.map(({ value, text }) => (
            <Select.Option value={value} key={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "timeEntryLocation"]}
        fieldKey={[field.fieldKey, "timeEntryLocation"]}
      >
        <Select style={{ maxWidth: 400, minWidth: 150 }} allowClear>
          <Select.Option value="TTMKE" key="TTMKE">
            TT Milwaukee
          </Select.Option>
          <Select.Option value="TTIOracle" key="TTIOracle">
            TTI Oracle
          </Select.Option>
        </Select>
      </Form.Item>
      <EntityStatusInput
        parentComponent="option-edit-location-value"
        field={field}
      />

      {!!isNew && (
        <RemoveFormItem
          parentComponent="option-edit-location-value"
          remove={() => remove(field.name)}
        />
      )}
    </Space>
  );
};

OptionEditLocationValue.propTypes = {
  isNew: bool,
  labelDisabled: bool,
  remove: func,
  field: optionFieldType.isRequired,
  availableDependantValues: arrayOf(optionType).isRequired,
};
